import { render, staticRenderFns } from "./headerContNew.vue?vue&type=template&id=4aca7496&scoped=true"
import script from "./headerContNew.vue?vue&type=script&lang=js"
export * from "./headerContNew.vue?vue&type=script&lang=js"
import style0 from "./headerContNew.vue?vue&type=style&index=0&id=4aca7496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aca7496",
  null
  
)

export default component.exports